import React, { useState, useEffect } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "../styles/FeaturedProperties.css";
import { HttpClient } from "../utils/HttpClient";
import PropertyCard from "../components/Property/Property";
import { MainContainer } from "../components/Styles";
import Loader from "../components/Loader";
const FeaturedProperties = ({ searchCriteria }) => {
  const [centerSlidePercentage, setCenterSlidePercentage] = useState(33.33);
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const httpClient = new HttpClient();
    const fetchProperties = async () => {
      try {
        const response = await httpClient.get(`/properties/all`);
        console.log("Fetched properties:", response.data);
        const limitedProperties = (response.data.data.properties || []).slice(
          0,
          5,
        );
        setProperties(limitedProperties);
      } catch (error) {
        console.error("Error fetching properties:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProperties();

    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setCenterSlidePercentage(100);
      } else {
        setCenterSlidePercentage(33.33);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, [searchCriteria]);
  return (
    <div className="featured-properties modern-featured-properties">
      <MainContainer>
        <div>
          <h2 className="modern-featured-title">Featured properties</h2>
          {loading ? (
            <Loader />
          ) : (
            <Carousel
              showArrows={false}
              autoPlay={true}
              infiniteLoop={true}
              centerMode={true}
              centerSlidePercentage={centerSlidePercentage}
              showStatus={false}
              showIndicators={true}
              showThumbs={false}
              className="property-carousel"
            >
              {properties.map((property) => (
                <div key={property.id} className="carousel-item-wrapper">
                  <PropertyCard
                    flexBasis={100}
                    propertyId={property.id}
                    imageUrl={property.Images?.[0]?.url || ""}
                    propertyType={property.property_type}
                    postedDate={new Date(
                      property.created_at,
                    ).toLocaleDateString()}
                    category={property.category}
                    price={property.price}
                    name={property.name}
                    propertyName={property.property_name}
                    address={`${property.town}, ${property.suburb}`}
                    town={property.town}
                    suburb={property.suburb}
                    bedrooms={property.bedrooms}
                    bathrooms={property.bathrooms}
                    landSize={parseInt(property.land_size) || 0}
                  />
                </div>
              ))}
            </Carousel>
          )}
        </div>
      </MainContainer>
    </div>
  );
};

export default FeaturedProperties;
